export const MIN_OPTIONS_TO_SEARCH = 7;
